module.exports = __webpack_public_path__ + "static/media/exclusive_app_bg.508d8c73.webp";